import { useCallback, useEffect, useRef, useState } from "react";
import { reportProgress } from "../api/services/classrooms";

export default function useVideoProgress(id, contentIndex) {
  const [playing, setPlaying] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const current = useRef(null);
  const pair = id + ":" + contentIndex;
  const flushEntry = useCallback((entry) => {
    if (!entry?.duration || !entry.dirty) return;
    entry.dirty = false;
    const data = { position: entry.position, duration: entry.duration, content_index: entry.index };
    reportProgress(entry.id, data).then(
      (response) => { if (current.current === entry) { setResult(response); setError(""); } },
      (failure) => { if (current.current === entry) setError(failure.message); }
    );
  }, []);
  useEffect(() => {
    const entry = { id, index: Number(contentIndex), position: 0, duration: 0, dirty: false };
    current.current = entry;
    setResult(null); setError(""); setPlaying(false);
    return () => { flushEntry(entry); if (current.current === entry) current.current = null; };
  }, [id, contentIndex, flushEntry]);
  useEffect(() => {
    if (!playing) return;
    const entry = current.current;
    const timer = setInterval(() => flushEntry(entry), 15000);
    return () => clearInterval(timer);
  }, [playing, pair, flushEntry]);
  const activeEntry = () => {
    const entry = current.current;
    return entry?.id === id && entry.index === Number(contentIndex) ? entry : null;
  };
  return {
    result, error,
    onPosition: (position) => {
      const entry = activeEntry();
      if (entry && Number.isFinite(position) && position >= 0 && entry.position !== position) {
        entry.position = position; entry.dirty = true;
      }
    },
    onDuration: (duration) => {
      const entry = activeEntry();
      if (entry && Number.isFinite(duration) && duration > 0) entry.duration = duration;
    },
    onPlay: () => setPlaying(true),
    onPause: () => { setPlaying(false); flushEntry(activeEntry()); },
    onEnded: () => {
      setPlaying(false);
      const entry = activeEntry();
      if (entry) { entry.position = entry.duration; entry.dirty = true; flushEntry(entry); }
    },
  };
}
